import { ReplaceVisasResponse, ReplaceVisasFailResponse } from 'api/evisaAPI/visas'
import type { CallAPIAction, Status } from 'api/types'
import { Bill } from 'common/types/transformedRespTypes'
import { UserEligibilityErrorMessages } from 'common/types/commonTypes'
import Actions from 'redux/actions'

type State = {
  issueRequestId: number
  bill?: Bill
  errorMessage: string | UserEligibilityErrorMessages
} & Status

const initialState = {
  issueRequestId: 0,
  errorMessage: '',
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.REPLACE_VISAS_ASYNC,
    Actions.REPLACE_VISAS_SUCCESS,
    Actions.REPLACE_VISAS_FAIL,
    ReplaceVisasResponse,
    ReplaceVisasFailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.REPLACE_VISAS_ASYNC: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.REPLACE_VISAS_SUCCESS: {
      const { payload } = action
      return {
        ...state,
        ...action.status,
        issueRequestId: payload.request.id,
        bill: !payload.request.bill
          ? undefined
          : {
              id: payload.request.bill.id,
              billNumber: payload.request.bill.bill_number,
              vat: payload.request.bill.vat,
              amount: payload.request.bill.amount,
              status: payload.request.bill.status,
              createdAt: payload.request.bill.created_at,
              expiryDate: payload.request.bill.expiry_date,
              paidAt: payload.request.bill.paid_at,
            },
      }
    }
    case Actions.REPLACE_VISAS_FAIL: {
      const { payload } = action
      return {
        ...state,
        errorMessage: payload?.error?.message || '',
        ...action.status,
      }
    }
    default:
      return state
  }
}
